'use strict';

require('../core/core');
require('../../modules/pagination/pagination');
require('../../modules/forms/forms');

require('../../models/ascent/ascents');
require('../../models/ascent/ascentTypes');
require('../../models/user/user');
require('../../models/user/userSendings');
require('../../models/user/userQualification');
require('../../models/user/userClub');
require('../../models/user/userAward');
require('../../models/user/userRelation');
require('../../models/mountains/regions');
require('../../models/mountains/peaks');
require('../../models/mountains/routes');
require('../../models/notice/notice');

require('../../forms/ascentEditForm');

require('../../helpers/show-modal-message/show-modal-message');

angular.module('far.profile', [
	'ngTouch',
	'angularFileUpload',
	'ui.select',
	'ui.bootstrap',
	'dekky.pagination',
	'dekky.forms',
	'far.models.ascents',
	'far.models.ascentTypes',
	'far.models.user',
	'far.models.userSendings',
	'far.models.userRelation',
	'far.models.userQualification',
	'far.models.userClub',
	'far.models.userAward',
	'far.models.mountains.regions',
	'far.models.mountains.peaks',
	'far.models.mountains.routes',
	'far.models.notice',
	'far.core',
	'far.forms.ascentEditForm',
	'far.helpers.showModalMessage'
]).value('formsConfig', {
	theme: '/dekky.forms/themes/far'
});
